import { Component, OnInit } from '@angular/core';
import * as fromRoot from '../../../../state/app.reducer';
import * as rootActions from '../../../../state/app.actions';
import * as fromReason from '../../../reason/state/reason.reducer';
import * as reasonActions from '../../../reason/state/reason.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {Reason} from '../../../../_models/reason';

@Component({
  templateUrl: './reason-edit-shell.component.html'
})

export class ReasonEditShellComponent implements OnInit {

    // errorMessage$: Observable<string>;
    reason$: Observable<Reason>;
    reasonTypes$: Observable<Reason[]>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromReason.State>
  ) {}

  ngOnInit() {

    this.reason$ = this.store.pipe(select(fromReason.getCurrentReason)) as Observable<Reason>;
    this.reasonTypes$ = this.store.pipe(select(fromReason.getReasonTypesList)) as Observable<Reason[]>;

  }

  saveReason(reasonIn: Reason): void {

    console.log('---> saveReason reasonIn:');
    console.log(reasonIn);

    if (reasonIn.id === null) {
      console.log('Se va a CREAR una nueva obra.');
      this.store.dispatch( new reasonActions.CreateReason(reasonIn));
    } else {
      console.log('Se va a MODIFICAR una obra existente.');
      this.store.dispatch( new reasonActions.UpdateReason(reasonIn));
    }
  }

  editReason(e: Event) {
    console.log('-> -> Pulsado botón editReason. Evento: ');
    console.log(e);

  }

  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando prodData-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal


} // End class ReasonEditShellComponent
